<template>
	<div class="same-register">
		<SelectListTab
			:value="selectedTab"
			:tabList="tabList"
			@input="changeTab"
		/>
		<table
			v-for="(list, idx) in sameList"
			:key="idx"
			class="table-main register__table"
		>
			<thead>
				<tr>
					<th class="register__table__id">회원번호</th>
					<th class="register__table__email">이메일주소(SNS)</th>
					<th class="register__table__name">닉네임</th>
					<th class="register__table__created">가입일</th>
					<th class="register__table__last">최근활동</th>
					<th class="register__table__button">조회</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in sameList[idx]" :key="item.idRegister">
					<td>{{ item.idRegister }}</td>
					<td>{{ item.email || '-' }}</td>
					<td>{{ item.nickName || '-' }}</td>
					<td>{{ item.createDate || '-' }}</td>
					<td>{{ item.lastDate || '-' }}</td>
					<td>
						<button class="btn-main blue">
							<router-link
								:to="`/register/register-info/${item.idRegister}`"
							>
								조회
							</router-link>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<PaginationBox
			:limit="limit"
			:offset="offset"
			:totalItem="totalItem"
			@to="onPagination($event.offset)"
		/>
	</div>
</template>
<script>
	import SelectListTab from '@/components/common/SelectListTab';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'SameRegister',
		components: {
			SelectListTab,
			PaginationBox,
		},
		data() {
			return {
				offset: 0,
				limit: 10,
				os: 'aos',
				sameList: [],
				tabList: ['안드로이드', '아이폰'],
				selectedTab: '안드로이드',
				totalItem: 0,
			};
		},
		created() {
			this.getList();
		},
		methods: {
			async getList() {
				try {
					const params = {
						os: this.os,
						offset: this.offset,
						limit: this.limit,
					};
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/register/duplicated/list`,
						{ params }
					);
					this.sameList = Object.values(data.data);
					this.totalItem = data.totalCount;
				} catch (err) {
					console.error(err);
					alert(
						'리스트를 불러오기에 실패하였습니다. 개발팀에 문의하세요.'
					);
				}
			},
			onPagination(offset) {
				this.offset = offset;
				this.getList();
			},
			changeTab(value) {
				if (this.selectedTab !== value) {
					this.os = value === '아이폰' ? 'ios' : 'aos';
					this.getList();
				}
				this.selectedTab = value;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.same-register {
		.register__table {
			margin: 20px 0 30px 0;

			.register__table__id {
				width: 100px;
			}
			.register__table__email {
				width: 500px;
			}
			.register__table__name {
				width: 400px;
			}
			.register__table__created,
			.register__table__last {
				width: 300px;
			}

			td {
				padding: 5px 8px;
			}

			.btn-main {
				height: 29px;
				line-height: 29px;
				min-width: 63px;
			}
		}
	}
</style>
